import { getIdToken, reload, User } from 'firebase/auth';

export const refreshSessionAndReloadApp = async (
  currentUser: User | null,
  options?: { afterNavigateTo?: string },
) => {
  if (!currentUser) {
    throw new Error('User session is not available');
  }

  await reload(currentUser);
  await getIdToken(currentUser, true);
  window.location.assign(options?.afterNavigateTo ?? '/');
};
